module.exports = __webpack_public_path__ + "8ea138eaa42ff698120969986c0f0524.png";